import { ArtModule } from 'modules/art';
import { CouponsModule } from 'modules/coupons';
import { HomeModule } from 'modules/home';
import { AuthModule } from '../modules/auth';
import { DemoModule } from '../modules/demo';
import { AssemblyModule } from "../modules/assembly";


export const modules = [
  new AuthModule(),
  new CouponsModule(),
  new HomeModule(),
  new ArtModule(),
  new DemoModule(),
  new AssemblyModule(),
];
